import { OPEN_THANKS_MODAL, CLOSE_THANKS_MODAL } from './types';

export const openThanksModal = () => ({
  type: OPEN_THANKS_MODAL,
});

export const closeThanksModal = () => ({
  type: CLOSE_THANKS_MODAL,
});
